// extracted by mini-css-extract-plugin
export default {"editorialContent":"_fcb75092","readMoreHeader":"_869d0cc6","article":"_e7a420fa","articleImageWrapper":"_303fffee","articleImage":"_5dcd345d","articleTitle":"_ec4276ba"};